<template>
    <v-container fluid grid-list-xl>
        <v-layout wrap align-center>
            <v-flex xs12>
                <h2 class="heading">Details</h2>
                <p class="signup-subheading">where does it hurt?</p>
            </v-flex>
            <v-flex xs12 d-flex pt-0 pb-0>
                <v-select
                        v-model="symptom.selectedGender"
                        :items="genders"
                        label="Gender"
                ></v-select>
            </v-flex>
            <v-flex xs12 d-flex pt-0 pb-0>
                <v-select
                        v-model="symptom.selectedYear"
                        :items="years"
                        label="Year of Birth"
                ></v-select>
            </v-flex>
            <v-flex xs12 d-flex pt-0 pb-0>
                <v-select v-model="symptom.selectedPart"
                          item-text="Name"
                          item-value="ID"
                          return-object
                          :items="bodyParts"
                          label="Select a Body Part"
                ></v-select>
            </v-flex>
            <v-flex xs12 d-flex pt-0 pb-0 v-if="symptom.selectedPart != null && symptom.selectedPart != ''">
                <v-select
                        v-model="symptom.selectedSubPart"
                        :items="symptom.selectedPart.Sub"
                        item-text="Name"
                        item-value="ID"
                        return-object
                        label="Select a Sub Body Part"
                ></v-select>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import priaid from '@/lib/priaid/Client'
    import {mapState} from 'vuex'

    export default {
        data() {
            return {
                e1: 1,
                genders: [
                    'Male',
                    'Female'
                ],
                years: [],
                bodyParts: null,
            }
        },
        computed: {
            ...mapState(
                ['symptom']
            )
        },
        created() {
            var year = new Date().getFullYear();

            for (var i = year; i > (year - 120); i--) {
                this.years.push(i);
            }

            this.bodyParts = priaid.getBodyParts();
        },
        mounted() {
            Loading.hide()
        }
    }
</script>